import { useState } from 'react';
import { Link } from 'react-router-dom';
import { articleList } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function TrendingSection() {
  const [showAll, setShowAll] = useState(false);
  const articles = articleList.filter((a) => a.isHot || a.isExplosive);
  const displayArticles = showAll ? articles : articles.slice(0, 8);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
              今日 <span className="text-primary-500">hottest</span> 塌房
            </h2>
            <p className="text-sm text-foreground-500 mt-1">每小时同步51区情报</p>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={() => setShowAll(!showAll)}
              className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              {showAll ? '收起' : '换一批'}
            </button>
            <Link
              to="/"
              className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              查看更多 <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {displayArticles.map((article) => (
            <ArticleCard
              key={article.id}
              id={article.id}
              title={article.title}
              excerpt={article.excerpt}
              categoryName={article.categoryName}
              publishedAt={article.publishedAt}
              cardImageUrl={article.cardImageUrl}
              views={article.views}
              comments={article.comments}
              isHot={article.isHot}
              isExplosive={article.isExplosive}
              variant="default"
            />
          ))}
        </div>
      </div>
    </section>
  );
}